<template>
  <div>
    <a-modal v-model="visible" width="1080px" title="编辑测试报告" ok-text="确认" cancel-text="取消" @ok="submit" @cancel="cancel">
      <a-form-model ref="modalForm" :model="modalForm" layout="vertical">
        <a-form-model-item label="" prop="name" :rules="{ required: true, message: '标题不能为空', trigger: 'blur' }">
          <a-input v-model="modalForm.name" style="width: 75%" />
          <a-radio-group v-model="modalForm.result" :options="resultOptions" style="margin-left: 20px" />
          <a-button type="primary" @click="send">发送报告</a-button>
        </a-form-model-item>
        <a-form-model-item label="参与人员">
          <a-descriptions size="small">
            <a-descriptions-item v-for="(userItems, index) in modalForm.workflow_users" :key="index" :label="userItems.role_name">
              <span v-for="user in userItems.users" :key="user.user_id"> {{ user.nickname }};</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-form-model-item>
        <a-form-model-item label="关联需求" prop="story_list" :rules="{ required: true, message: '关联需求不能为空' }">
          <report-requirement :data-source="modalForm.story_list" @requirement-change="requirementChange" />
        </a-form-model-item>
        <a-form-model-item label="测试总结" prop="summary">
          <am-editor :content="modalForm.summary" :drag="true" height="150px" @change="summaryChange" />
        </a-form-model-item>
        <a-form-model-item label="风险提示" prop="risk">
          <am-editor :content="modalForm.risk" :drag="true" height="150px" @change="riskChange" />
        </a-form-model-item>
        <a-form-model-item label="测试分析" prop="analysis">
          <a-row :gutter="8">
            <a-col v-for="(testPlan, index) in modalForm.testPlans" :key="index" :span="12">
              <a-card hoverable class="service-card">
                <span class="service-card-header">
                  <a class="service-card-header_name" :href="planLink(testPlan)" target="_blank"> {{ testPlan.name }} </a>
                  <!-- <a-dropdown placement="bottomCenter" class="service-card-header_action">
                    <a> <a-icon type="more" /> </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a href="javascript:;" @click="onDelete(index)">删除</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown> -->
                </span>
                <span class="service-card-content">
                  <span class="service-card_lable">测试用例总数:</span>
                  <span class="service-card-content_value">{{ testPlan.total_cases }}</span>
                </span>
                <span class="service-card-content">
                  <span class="service-card_lable">执行通过总计:</span>
                  <span class="service-card-content_value">{{ testPlan.finished_cases }}</span>
                </span>
                <span class="service-card-content">
                  <span class="service-card_lable">通过率:</span>
                  <span class="service-card-content_value">{{ testPlan.progress }}%</span>
                </span>
              </a-card>
            </a-col>
            <!-- <a-col :span="12">
              <a-card class="service-card add-service-card" hoverable @click="showTestPlanSelector">
                <span class="add-service-card_button"><a-icon type="plus" /> 添加测试计划</span>
              </a-card>
            </a-col> -->
            <a-col v-if="modalForm.testPlans.length <= 0" :span="12">
              <p>未关联测试计划</p>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="缺陷统计" prop="bug">
          <a-table :pagination="false" :columns="columns" size="small" :data-source="bugData" row-key="id" />
        </a-form-model-item>
        <a-form-model-item label="遗留问题" prop="bug">
          <!-- <a-table v-if="remainBugData.length > 0" :pagination="false" :columns="remainBugColumns" size="small" :data-source="remainBugData" :show-header="false" row-key="id"> -->
          <template v-if="remainBugData.length > 0"><issueReport :source-data="remainBugData" /></template>
          <!-- <span
              slot="name"
              slot-scope="text, record"
            ><a class="custom-link" :href="issueLink(record)" target="_blank">{{ record.key }} </a>{{ record.title }}</span> -->
          <!-- </v-if="remainbugdata.length></a-table> -->
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <report-test-plan-modal :is-show.sync="testPlanVisible" :project-id="projectId" @test-plan-change="testPlanChange" />
  </div>
</template>

<script>
import { bugStats } from '@/api/project/testPlan';
import { hasUploadingImages } from '@/utils/utils';
import { workflowTestPlans } from '@/api/project/workflow';
import { addTestReport, getReportDetail, updateTestReport, sendTestReport } from '@/api/project/testReport';

import AmEditor from '@/components/AmEditor/index';
import IssueReport from '@/pages/project/issue/components/IssueReport';
import ReportRequirement from '@/pages/project/workflow/components/ReportRequirement';
import ReportTestPlanModal from '@/pages/project/workflow/components/ReportTestPlanModal';

const columns = [
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: 'P0',
    dataIndex: 'P0',
    key: 'P0',
    width: 100,
    scopedSlots: { customRender: 'P0' }
  },
  {
    title: 'P1',
    dataIndex: 'P1',
    key: 'P1',
    width: 100,
    scopedSlots: { customRender: 'P1' }
  },
  {
    title: 'P2',
    dataIndex: 'P2',
    key: 'P2',
    width: 100,
    scopedSlots: { customRender: 'P2' }
  },
  {
    title: 'P3',
    dataIndex: 'P3',
    key: 'P3',
    width: 100,
    scopedSlots: { customRender: 'P3' }
  },
  {
    title: 'P4',
    dataIndex: 'P4',
    key: 'P4',
    width: 100,
    scopedSlots: { customRender: 'P4' }
  },
  {
    title: '总计',
    dataIndex: 'total',
    key: 'total',
    width: 100,
    scopedSlots: { customRender: 'total' }
  }
];

const remainBugColumns = [
  // {
  //   title: 'name',
  //   dataIndex: 'name',
  //   key: 'name',
  //   width: 250,
  //   scopedSlots: { customRender: 'name' }
  // },
  {
    title: 'serious',
    dataIndex: 'serious',
    key: 'serious',
    width: 250,
    scopedSlots: { customRender: 'serious' }
  },
  {
    title: 'creator',
    dataIndex: 'creator',
    key: 'creator',
    width: 250,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: 'status',
    dataIndex: 'status',
    key: 'status',
    width: 250,
    scopedSlots: { customRender: 'status' }
  }
];

const resultOptions = [
  { label: '通过', value: 1 },
  { label: '不通过', value: 2 }
];

export default {
  name: 'TestReportModal',
  components: { AmEditor, ReportTestPlanModal, ReportRequirement, IssueReport },
  props: {
    workflowId: {
      type: [Number, String],
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    workflowUsers: {
      type: Array,
      default: () => {
        return [];
      }
    },
    storyList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    testPlans: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      remainBugColumns,
      projectId: parseInt(this.$route.params.project_id) || null,
      resultOptions,
      visible: this.isShow,
      modalForm: {
        id: null,
        title: this.title,
        result: 1,
        testPlans: [],
        story_list: []
      },
      labelCol: { span: 5 },
      // wrapperCol: { span: 30 },
      workflowStoryList: {},
      testPlanVisible: false,
      bugData: [],
      remainBugData: []
    };
  },
  computed: {
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    },
    issueLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          query: { issueId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      this.getReportDetail();
    },
    title: {
      immediate: true,
      handler(val) {
        this.modalForm.name = val;
      }
    },
    workflowUsers: {
      immediate: true,
      handler(val) {
        this.modalForm.workflow_users = val;
      }
    },
    testPlans: {
      immediate: true,
      handler(val) {
        this.modalForm.testPlans = val;
      }
    },
    storyList: {
      immediate: true,
      handler(val) {
        if (val) {
          this.modalForm.story_list = val;
          let requirementIds = [];
          if (this.storyList) {
            requirementIds = this.storyList.map(req => req.id);
          }
          bugStats({ project_id: this.projectId, requirement_ids: requirementIds }).then(res => {
            this.bugData = res.data.summary;
            this.remainBugData = res.data.remain;
          });
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    requirementChange(index) {
      this.modalForm.story_list.splice(index, 1);
    },
    summaryChange(content) {
      this.modalForm.summary = content;
    },
    riskChange(content) {
      this.modalForm.risk = content;
    },
    showTestPlanSelector() {
      this.testPlanVisible = true;
    },
    testPlanChange(rows) {
      this.modalForm.testPlans = [];
      this.modalForm.testPlans.push(...rows);
      this.testPlanVisible = false;
      this.getBugStats();
    },
    onDelete(index) {
      this.modalForm.testPlans.splice(index, 1);
      this.getBugStats();
    },
    getBugStats() {
      const planIds = this.modalForm.testPlans.map(plan => plan.id);
      bugStats({ project_id: this.projectId, plan_ids: planIds }).then(res => {
        this.bugData = res.data.summary;
        this.remainBugData = res.data.remain;
      });
    },
    getReportDetail() {
      if (this.workflowId) {
        workflowTestPlans({ workflow_id: this.workflowId, project_id: this.projectId }).then(res => {
          this.modalForm.testPlans = res.data.items;
        });
        getReportDetail({ workflow_id: this.workflowId }).then(res => {
          if (Object.keys(res.data).length === 0) {
            return;
          }
          this.modalForm.id = res.data.id;
          this.modalForm.name = res.data.name;
          this.modalForm.result = res.data.result;
          this.modalForm.summary = res.data.summary;
          this.modalForm.risk = res.data.risk;
          // this.modalForm.testPlans = res.data.test_plans;
          let requirementIds = [];
          if (this.storyList) {
            requirementIds = this.storyList.map(plan => plan.id);
          }
          bugStats({ project_id: this.projectId, requirement_ids: requirementIds }).then(res => {
            this.bugData = res.data.summary;
            this.remainBugData = res.data.remain;
          });
        });
      }
    },
    submit() {
      if (hasUploadingImages(this.modalForm.summary) || hasUploadingImages(this.modalForm.risk)) {
        this.$message.warning('有图片正在上传中，请等待上传完成或去除上传中的图片再提交哦~');
        return;
      }
      if (this.modalForm.id == null) {
        addTestReport({
          ...this.modalForm,
          project_id: this.projectId,
          workflow_id: this.workflowId,
          test_plans: this.modalForm.testPlans
        }).then(() => {
          this.$message.success('创建测试报告成功!');
        });
      } else {
        updateTestReport({
          ...this.modalForm,
          project_id: this.projectId,
          workflow_id: this.workflowId,
          test_plans: this.modalForm.testPlans
        }).then(() => {
          this.$message.success('更新测试报告成功!');
        });
      }
      this.$emit('cancel');
    },
    send() {
      if (this.modalForm.id == null) {
        this.$message.success('请先点击底部【确认】完成测试报告的创建!');
      } else {
        updateTestReport({
          ...this.modalForm,
          project_id: this.projectId,
          workflow_id: this.workflowId,
          test_plans: this.modalForm.testPlans
        }).then(() => {
          this.$message.success('更新测试报告成功!');
        });
        const current_workflow = this.workflowId;
        const self = this;
        self.$confirm({
          title: '确认',
          content: '请仔细检查报告内容！是否确定发送测试报告？',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          async onOk() {
            sendTestReport({ workflow_id: current_workflow }).then(() => {
              self.$message.success('测试报告发送成功!');
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.roleName {
  background-color: gainsboro;
  text-align: center;
}

.add-service-card {
  height: 149px;
  text-align: center;
  border: 1px dashed rgb(207, 207, 207);

  .add-service-card_button {
    line-height: 100px;
  }
}

.service-card {
  margin: 4px 0;

  .service-card-header {
    display: block;

    .service-card-header_name {
      display: inline-block;
      height: 24px;
      // margin-left: 8px;
      font-size: 16px;
      line-height: 24px;
      vertical-align: top;
      color: #1890ff;
    }

    .service-card-header_action {
      height: 24px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 16px;
      float: right;
    }
  }

  .service-card-content {
    margin-top: 4px;
    display: block;

    .service-card-content_value {
      margin-left: 8px;
    }
  }

  .service-card-footer {
    display: block;

    .service-card-footer_value {
      margin-left: 8px;
    }
  }

  .service-card_lable {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    font-size: 14px;
  }
}
</style>
